// FirstTimeSignInForm.tsx
import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { EmailTextField, PasswordTextField } from "./TextField";
import { FirstTimeSignInFormData, firstTimeSignInSchema } from "./validationSchema";

interface FirstTimeSignInFormProps {
    onSubmit: (data: FirstTimeSignInFormData) => void;
    onBack: () => void;
}

export default function FirstTimeSignInForm({ onSubmit, onBack }: FirstTimeSignInFormProps): JSX.Element {
    const [showTempPassword, setShowTempPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);

    const methods = useForm<FirstTimeSignInFormData>({
        resolver: zodResolver(firstTimeSignInSchema),
        mode: "onChange"
    });
    const { formState } = methods;

    return (
        <FormProvider {...methods}>
            <Box component="form" onSubmit={methods.handleSubmit(onSubmit)}>
                <Typography variant="h4" textAlign="center" gutterBottom color="primary">
                    First Time Sign In
                </Typography>
                <EmailTextField label="Email" placeholder="Enter your email" fullWidth margin="normal" />
                <PasswordTextField
                    label="Temporary Password"
                    placeholder="Enter temporary password"
                    fullWidth
                    margin="normal"
                    showPassword={showTempPassword}
                    onTogglePasswordVisibility={() => setShowTempPassword((prev) => !prev)}
                />
                <PasswordTextField
                    label="New Password"
                    placeholder="Enter new password"
                    fullWidth
                    margin="normal"
                    showPassword={showNewPassword}
                    onTogglePasswordVisibility={() => setShowNewPassword((prev) => !prev)}
                />
                <PasswordTextField
                    label="Confirm New Password"
                    placeholder="Confirm new password"
                    fullWidth
                    margin="normal"
                    showPassword={showNewPassword}
                    onTogglePasswordVisibility={() => setShowNewPassword((prev) => !prev)}
                />
                <Button variant="contained" type="submit" fullWidth sx={{ mt: 2 }} disabled={!formState.isValid}>
                    Submit
                </Button>
                <Button variant="text" type="button" fullWidth sx={{ mt: 1 }} onClick={onBack}>
                    Back to Login
                </Button>
            </Box>
        </FormProvider>
    );
}
